export default "__VITE_ASSET__BKHTUXX2__"